import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  tagsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    // padding: '0 8px 6px 0',
    width: '100%',
    maxWidth: '100%'
    // [theme.breakpoints.up('lg')]: {
    //   padding: '8px 0',
    // }
  },
  tagsList: {
    display: 'flex',
    gap: '4px',
    flexWrap: 'wrap',
    width: '100%',
    maxWidth: '100%',
  },
  tagButton: {
    borderRadius: '8px',
    padding: '0',
    color: theme.palette.gray_300.main,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.blue_300.main
    }
  },
  tagBadgeItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    height: '20px',
    // color: theme.palette.gray_400.main,
    fontSize: '11px',
    // fontWeight: '600',
    textTransform: 'uppercase',
    '& span': {
      padding: '0 8px'
    }
    // '& svg': {
    //   width: '16px',
    //   height: '16px'
    // }
  },
  boxTagCategory: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginBottom: '8px'
  },

  title: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: '500',
    color: theme.palette.blue_300.main,
    marginBottom: '4px'
  },

  dialogTitle: {
    margin: 0,
    color: theme.palette.blue_300.main
    // padding: theme.spacing(2)
  },
  tagsBadgeContainer: {
    display: 'flex',
    gap: '8px'
  },
  tagGrid: {
    // padding: theme.spacing(2)
  },
  tagChip: {
    // margin: theme.spacing(0.5),
    transition: 'all 0.3s ease',
    '&:hover': {
      opacity: 0.8
    }
  },
  emptyTags: {
    fontFamily: 'Inter, sans-serif',
    color: theme.palette.gray_400.main
  }
}))
